import {Decoder, field, object, string} from 'json-bouncer'
import {nullableWithDefaultDecoder} from '../Data/DecodeHelper'
import {Order} from './Order'

export interface InvoiceAddress {
    readonly invoiceName1: string
    readonly invoiceName2: string
    readonly invoiceName3: string
    readonly invoiceName4: string
    readonly invoiceStreet: string
    readonly invoiceHouseNumber: string
    readonly invoiceZipCode: string
    readonly invoiceCity: string
    readonly invoiceCountry: string
}

export function invoiceAddressDecoder(): Decoder<InvoiceAddress> {
    return object({
        invoiceName1: field('invoiceName1', string()),
        invoiceName2: field('invoiceName2', nullableWithDefaultDecoder('', string())),
        invoiceName3: field('invoiceName3', nullableWithDefaultDecoder('', string())),
        invoiceName4: field('invoiceName4', nullableWithDefaultDecoder('', string())),
        invoiceStreet: field('invoiceStreet', nullableWithDefaultDecoder('', string())),
        invoiceHouseNumber: field('invoiceHouseNumber', nullableWithDefaultDecoder('', string())),
        invoiceZipCode: field('invoiceZipCode', string()),
        invoiceCity: field('invoiceCity', string()),
        invoiceCountry: field('invoiceCountry', string()),
    })
}

export function fromOrder(order: Order): InvoiceAddress {
    const {
        invoiceName1,
        invoiceName2,
        invoiceName3,
        invoiceName4,
        invoiceStreet,
        invoiceHouseNumber,
        invoiceZipCode,
        invoiceCity,
        invoiceCountry,
    } = order
    return {
        invoiceName1,
        invoiceName2,
        invoiceName3,
        invoiceName4,
        invoiceStreet,
        invoiceHouseNumber,
        invoiceZipCode,
        invoiceCity,
        invoiceCountry,
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InvoiceAddress.ts